export default __webpack_public_path__ + "static/media/payroll_blue.fe52dff4.svg";